import { TFunction, TranslateEnumFunction } from 'language/translator'
import {
  ComparativePeriod,
  CustomPeriodFilter,
  DateFilterType,
  ForecastPeriod,
  PeriodFilter
} from 'types/GlobalWidget'
import { getParsedDateSpan } from 'utils/dateParser'

import { isCustomPeriodFilter } from 'utils/functions'

export function getComparativePeriodLabel(
  displayedPeriodFilter: CustomPeriodFilter | PeriodFilter,
  displayedPeriodType: 'dashboard' | 'widget',
  comparativePeriod: ComparativePeriod | null,
  comparativePeriodFromDate: string,
  comparativePeriodToDate: string,
  isPoint: boolean,
  forecastPeriod: ForecastPeriod | null,
  t: TFunction,
  translateEnum: TranslateEnumFunction
) {
  if (!comparativePeriod) {
    return null
  }

  const isCustom = isCustomPeriodFilter(displayedPeriodFilter)

  if (isCustom) {
    return getParsedDateSpan(comparativePeriodFromDate, comparativePeriodToDate)
  }

  let label = ''

  if (displayedPeriodFilter) {
    const dateFilterType = isPoint
      ? DateFilterType.POINT
      : DateFilterType.PERIOD

    label = translateEnum('comparative_periods', dateFilterType)[
      displayedPeriodFilter
    ][comparativePeriod]
  }

  if (forecastPeriod && displayedPeriodType === 'widget') {
    label += ` ${t('global', 'and', true)} ${translateEnum(
      'forecast_periods',
      forecastPeriod
    ).title.toLowerCase()}`
  }

  return label
}

export function getPeriodLabel(
  displayedPeriodFilter: CustomPeriodFilter | PeriodFilter,
  displayedPeriodType: 'dashboard' | 'widget',
  forecastPeriod: ForecastPeriod | null,
  restrictToPeriod: boolean,
  t: TFunction,
  translateEnum: TranslateEnumFunction
) {
  const isCustom = isCustomPeriodFilter(displayedPeriodFilter)

  if (isCustom) {
    return getParsedDateSpan(
      displayedPeriodFilter.from,
      displayedPeriodFilter.to
    )
  }

  let label = ''

  if (displayedPeriodFilter) {
    label = translateEnum('period_filters', displayedPeriodFilter).title
  }

  if (restrictToPeriod) {
    label += ` ${t('date_filters', 'until_latest_closed_accounting_period')}`
  }

  if (forecastPeriod && displayedPeriodType === 'widget') {
    label += ` ${t('global', 'and', true)} ${translateEnum(
      'forecast_periods',
      forecastPeriod
    ).title.toLowerCase()}`
  }

  return label
}

export const getDisplayedPeriod = (
  dashboardCustomPeriodFilter: CustomPeriodFilter | null,
  dashboardPeriodFilter: PeriodFilter | null,
  isLocked: boolean,
  widgetPeriodFilter: PeriodFilter
): {
  filter: CustomPeriodFilter | PeriodFilter
  type: 'dashboard' | 'widget'
} => {
  if (!isLocked && dashboardCustomPeriodFilter) {
    return {
      filter: dashboardCustomPeriodFilter,
      type: 'dashboard'
    }
  }

  if (!isLocked && dashboardPeriodFilter) {
    return {
      filter: dashboardPeriodFilter,
      type: 'dashboard'
    }
  }

  return {
    filter: widgetPeriodFilter,
    type: 'widget'
  }
}
